import { z } from "zod";
export const TokenUsageBucketSize = z.enum(["hour", "day", "week"]);
export const TokenUsageQuery = z.object({
    /** ISO-8601 lower bound (inclusive). Defaults to 30 days ago. */
    from: z.string().datetime().optional(),
    /** ISO-8601 upper bound (exclusive). Defaults to now. */
    to: z.string().datetime().optional(),
    /** Histogram bucket granularity. Defaults to "day". */
    bucket: TokenUsageBucketSize.default("day"),
    /** Optional repo filter — restricts results to usage attributed to a repo. */
    repoId: z.string().uuid().optional(),
    /** Optional conversation filter. */
    conversationId: z.string().uuid().optional(),
    /** Optional user filter. */
    userId: z.string().uuid().optional(),
    /** Optional task filter (e.g. "qa_chat", "embed"). */
    task: z.string().optional(),
});
const Aggregate = z.object({
    inputTokens: z.number().int(),
    outputTokens: z.number().int(),
    cachedInputTokens: z.number().int(),
    totalTokens: z.number().int(),
    costUsd: z.number(),
    requests: z.number().int(),
});
export const TokenUsageBucket = Aggregate.extend({
    /** Start of the bucket window (ISO-8601). */
    bucket: z.string().datetime(),
});
export const TokenUsageRepoRow = Aggregate.extend({
    repoId: z.string().uuid().nullable(),
    repoName: z.string().nullable(),
});
export const TokenUsageConversationRow = Aggregate.extend({
    conversationId: z.string().uuid().nullable(),
    conversationTitle: z.string().nullable(),
});
export const TokenUsageUserRow = Aggregate.extend({
    userId: z.string().uuid().nullable(),
    userName: z.string().nullable(),
    userEmail: z.string().nullable(),
});
export const TokenUsageTaskRow = Aggregate.extend({
    task: z.string(),
});
export const TokenUsageModelRow = Aggregate.extend({
    providerKind: z.string(),
    model: z.string(),
});
export const TokenUsageResponse = z.object({
    range: z.object({
        from: z.string().datetime(),
        to: z.string().datetime(),
        bucket: TokenUsageBucketSize,
    }),
    totals: Aggregate,
    buckets: z.array(TokenUsageBucket),
    byRepo: z.array(TokenUsageRepoRow),
    byConversation: z.array(TokenUsageConversationRow),
    byUser: z.array(TokenUsageUserRow),
    byTask: z.array(TokenUsageTaskRow),
    byModel: z.array(TokenUsageModelRow),
});
//# sourceMappingURL=token-usage.js.map